var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_121)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60821 3H13.6323L18.7301 8.32117V18.6547C18.7301 19.9489 17.6856 21 16.3914 21H7.60821C6.32062 21 5.26953 19.9489 5.26953 18.6547V5.33868C5.26951 4.05109 6.32062 3 7.60821 3Z",
    fill: "#00733B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.626 3V8.27518H18.7304L13.626 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8666 16.1052H9.9929L9.3951 15.1L8.79728 16.1052H7.91699L8.95496 14.3577L8.04183 12.8402H8.92209L9.39508 13.6285L9.86149 12.8402H10.7418L9.8352 14.3643L10.8666 16.1052ZM11.1754 16.1052V12.8402H12.0097V15.3956H13.4287V16.1051H11.1754V16.1052ZM14.8082 16.1446C14.4797 16.1446 14.1907 16.0394 13.9411 15.8358C13.698 15.6387 13.5601 15.3891 13.5403 15.0935L14.2564 14.8833C14.2761 15.0409 14.3418 15.1789 14.4535 15.284C14.5717 15.3891 14.7031 15.4416 14.8477 15.4416C14.9659 15.4416 15.0644 15.4154 15.1433 15.3628C15.2155 15.3103 15.2549 15.238 15.2549 15.1526C15.2549 15.0804 15.2221 15.0212 15.163 14.9687C15.1038 14.9227 15.025 14.8833 14.933 14.8504C14.8411 14.8176 14.7294 14.7847 14.6177 14.7584C14.4995 14.7256 14.3812 14.6862 14.2695 14.6336C14.1513 14.5877 14.0462 14.5285 13.9542 14.4563C13.8557 14.3906 13.7834 14.292 13.7243 14.1672C13.6651 14.049 13.6323 13.9044 13.6323 13.7402C13.6323 13.4709 13.744 13.2475 13.9739 13.0701C14.2038 12.8862 14.4797 12.8008 14.8016 12.8008C15.1235 12.8008 15.406 12.8796 15.6425 13.0307C15.879 13.1884 16.0301 13.392 16.0892 13.6417L15.3403 13.957C15.3075 13.819 15.2418 13.7074 15.1498 13.622C15.0578 13.5431 14.9396 13.4971 14.8016 13.4971C14.6965 13.4971 14.6177 13.5234 14.552 13.5629C14.4929 13.6023 14.4666 13.6614 14.4666 13.7337C14.4666 13.7994 14.506 13.8585 14.5848 13.9045C14.6637 13.9439 14.7688 13.9767 14.887 13.9964C15.0053 14.0161 15.1367 14.049 15.2746 14.095C15.4191 14.1475 15.544 14.2001 15.6688 14.2723C15.787 14.338 15.8856 14.4497 15.9644 14.5942C16.0498 14.7453 16.0892 14.9227 16.0892 15.1264C16.0892 15.4285 15.971 15.6782 15.7344 15.8621C15.4979 16.046 15.1893 16.1446 14.8082 16.1446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/XLS.87abbbc5d3a55aa9d41f81049d4707d7.svg";
export { ForwardRef as ReactComponent };